import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, Paper, Box, Skeleton } from '@mui/material'
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import Masonry from '@mui/lab/Masonry';
import HealthShelfContainer from "./partials/healthshelf/HealthShelfContainer";
import FilterComponent from "./partials/healthshelf/FilterComponent";
import { topicHydrate } from "../reducers/healthshelf_topic";
import { articleHydrate } from "../reducers/healthshelf_article";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import ArticleDialog from "./partials/healthshelf/ArticleDialog";
import { fetchHealthShelfs, selectHealthShelfById } from "../reducers/healthshelf_single";
import RecipeDialog from "./partials/healthshelf/RecipeDialog";
import HowToDialog from "./partials/healthshelf/HowToDialog";
import TrackerDialog from "./partials/healthshelf/TrackerDialog";
import SelfCheckDialog from "./partials/healthshelf/SelfCheckDialog";
import ChallengeDialog from "./partials/healthshelf/ChallengeDialog";
import { recordInteractions } from "../reducers/interaction";

const HealthShelfArticle = () => {
    const { user: currentUser } = useSelector((state) => state.auth);

    useEffect(()=>{
        if(window !== undefined){
          window.scrollTo(0,0)
        }
      },[])
      
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [searchParams] = useSearchParams();
    const ArticleGuid = searchParams.get("hsg")
    const Article = useSelector(state => selectHealthShelfById(state, ArticleGuid))
    const ArticleStatus = useSelector(state => state.healthshelfs.statusSingle)
    const GroupGuid = localStorage.getItem("group")
    useEffect(() => {

        if (ArticleStatus === 'idle' && ArticleGuid && currentUser) {

            dispatch(fetchHealthShelfs({ AuthToken: currentUser.AuthToken, HealthShelfId_Guid: ArticleGuid }))
            dispatch(recordInteractions({GroupGuid:GroupGuid, AuthToken: currentUser.AuthToken,ClassKeyName:"ARTICLE",FamilyKeyName:"LOADED",TypeKeyName:"HEALTH SHELF", ComponentGuid:ArticleGuid}))
        }
    }, [dispatch, Article, ArticleStatus, currentUser, ArticleGuid])

    const ArticleSwitch = () => {

        if (Article.Type === "ARTICLE") { return <ArticleDialog Article={Article} /> }
        else if (Article.Type === "RECIPE") { return <RecipeDialog Article={Article} /> }
        else if (Article.Type === "HOW TO") { return <HowToDialog Article={Article} /> }
        else if (Article.Type === "TRACKER") { return <TrackerDialog Article={Article} /> }
        else if (Article.Type === "SELF CHECK") { return <SelfCheckDialog Article={Article} /> }
        else if (Article.Type === "CHALLENGE") { return <ChallengeDialog Article={Article} /> }
        return (
            <Paper elevation={1} style={{ marginTop: '150px', padding: '40px' }}>
                <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <Box p={2} mt={1}>
                            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                                <Grid item xs={12}>

                                    <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "30%", width: "100%" }} />
                                    <Box p={2}>
                                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                            <Grid item xs={12}>
                                                <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "10%", width: "100%" }} />
                                            </Grid>
                                            <Grid item xs={10} >
                                                <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "45%", width: "100%" }} />
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        )

    }

    return (
        <div>
            <Header />


            {
                ArticleStatus === 'success'
                    ? <ArticleSwitch />

                    : (
                        <Paper elevation={1} style={{ marginTop: '150px', padding: '40px' }}>
                            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2}>
                                <Grid item xs={12}>
                                    <Box p={2} mt={1}>
                                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                                            <Grid item xs={12}>

                                                <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "30%", width: "100%" }} />
                                                <Box p={2}>
                                                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                                        <Grid item xs={12}>
                                                            <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "10%", width: "100%" }} />
                                                        </Grid>
                                                        <Grid item xs={10} >
                                                            <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "45%", width: "100%" }} />
                                                        </Grid>
                                                    </Grid>
                                                </Box>

                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    )
            }
            <Footer />
        </div>
    );

};

export default HealthShelfArticle;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */